import React from 'react'
import { LINKS } from '@common/consts'
import CommunityButton from '@components/community-button'

const CommunityCreateProjectButton = ({ className = '' }) => {
  return (
    <CommunityButton
      className={className}
      tag='anchor'
      href={LINKS.STUDIO_WELCOME}
      icon='plus'
      iconPlacement='left'
    >
      Create project
    </CommunityButton>
  )
}

export default CommunityCreateProjectButton
